import { Fragment } from 'react';

import { SmartTableCellProps } from '@/components/ui/daisy';
import { formatLessonNamePrefix } from '@/utils/lesson/name';

import ActivityProgress from '@/models/ActivityProgress';

export default function ActivityLessonCell({
  item,
}: SmartTableCellProps<ActivityProgress>) {
  const { lesson } = item;

  if (lesson?.order == null) return null;

  return (
    <Fragment>{formatLessonNamePrefix({ lessonOrder: lesson.order })}</Fragment>
  );
}
